import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { HistoryElement, useAppStateSelector } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function History() {
    const historyItems = useAppStateSelector(state => state.historyItems)

    // if (!historyItems || !historyItems.length) {
    //     return
    // }

    useEffect(() => {
        nostojs(api => api.createRecommendationRequest()
            .setElements(['ns-autocomplete-rec'])
            .load()
        )
    }, [])

    return (
        <div class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto">
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-d-flex ns-flex-column ns-flex-sm-row">
                    <div class="ns-autocomplete-keywords">
                        {historyItems.length >= 1 && <><div class="ns-autocomplete-header">Recently Searched</div>
                        <div class="ns-d-flex ns-flex-column ns-searched">
                            {historyItems?.slice(0, defaultConfig.historySize).map(item => (
                                <HistoryElement key={item} query={{ query: item }}>
                                    <div class="ns-keyword">{item}</div>
                                </HistoryElement>
                            ))}
                        </div>
                        </>}

                        <div class="ns-autocomplete-header ns-trending">Trending Searches</div>
                        <div class="ns-d-flex ns-flex-column">
                            {window.nostoSearchTerms?.map(term => (
                                <div class="ns-trending-search ns-keyword"><a href={`https://www.greats.com/pages/search-results?q=${term.replaceAll(" ", "+")}`}>{term}</a></div>
                            ))}
                            {/* <div class="ns-trending-search ns-keyword">High rise jeans</div>
                            <div class="ns-trending-search ns-keyword">Green shirt</div>
                            <div class="ns-trending-search ns-keyword">Swimming</div>
                            <div class="ns-trending-search ns-keyword">Summer shorts</div>
                            <div class="ns-trending-search ns-keyword">Tank tops</div> */}
                        </div>
                    </div>
                    <div class="nosto_element" id="ns-autocomplete-rec"></div>
                </div>
            </div>
        </div>
    )
}
